import { LogoutOutlined, UserOutlined } from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { Avatar as AntdAvatar, Layout, theme } from 'antd'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { ReactComponent as HospitalIcon } from '../../assets/hospital.svg'
import CyIconDropdownButton from '../../components/CyIconDropdownButton/CyIconDropdownButton'
import { LOGIN_PATH } from '../../constants/pathConstant'
import {
  getHospitalName,
  getImageUrl,
  removeToken,
  selectHospitalName,
  selectImageUrl,
  selectProfileName,
  selectProfilePictureImage,
} from '../../state/auth/authReducer'
import AccountScreen from '../AccountScreen/AccountScreen'
const { Header: AntdHeader } = Layout

const CenterContainer = styled.h2`
  margin: 0px;
  padding: 0px;
  flex: 1;
  & svg {
    width: 23px;
    height: 23px;
  }
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: center;
  @media (max-width: 1200px) {
    justify-content: flex-start;
     margin: 0px 40px;
     order:1;
  }
`
const Avatar = styled(AntdAvatar)`
  width: 30px;
  height: 30px;
  border-radius: 100%;
  margin: 0px 5px;
`

const IconImage = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 100%;
  margin: 0px 5px;
  border: 1px solid #e3e3e3;
`

const LeftContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin-left: 20px;
  color: grey;
  & * {
    margin-bottom: 0px;
  }   
  @media (max-width: 1200px) {
    order: 2;
    justify-content: flex-start;
     margin: 0px 20px;
  }
`

const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex: 1;
  justify-content: flex-end;
  margin-right: 20px;
  @media (max-width: 1200px) {
    justify-content: flex-start;
     margin: 0px 0px;
     order:3;
  }
`

const ProfileNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-right: 10px;
  font-weight: 500;
  font-size: 1em;
  color: grey;
  @media (max-width: 1200px) {
    justify-content: flex-start;
     margin: 0px 20px;
  }
`
type HeaderProps = {
  title: JSX.Element
}

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: white !important;
  width: 100%;
  @media (max-width: 1200px) {
    flex-direction: column;
    gap: 0px;    
  }
  
`
function Header({ title }: HeaderProps) {
  const [openAccountDrawer, setOpenAccountDrawer] = useState<boolean>(false)
  const {
    token: { colorBgContainer },
  } = theme.useToken()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getHospitalName())
  }, [])
  const hospitalName = useSelector(selectHospitalName)
  const [imageUrl, setImageUrl] = useState<string>()
  const fileName = useSelector(selectProfilePictureImage)
  const profileName = useSelector(selectProfileName)
  const profileImage = useSelector(selectImageUrl)
  useEffect(() => {
    dispatch(getImageUrl(fileName))
  }, [fileName])
  const accountItems: MenuProps['items'] = [
    {
      key: '1',
      label: 'My Account',
      icon: <UserOutlined />,
      onClick: () => {
        setOpenAccountDrawer(true)
      },
    },
    {
      key: '2',
      label: 'Log Out',
      icon: <LogoutOutlined />,
      onClick: () => {
        dispatch(removeToken())
        navigate(LOGIN_PATH)
      },
    },
  ]
  return (
    <>
      <AccountScreen
        open={openAccountDrawer}
        onClose={() => setOpenAccountDrawer(false)}
      />
      <AntdHeader style={{ background: colorBgContainer, padding: '0px 10px' }}>
        <HeaderContainer>
          <LeftContainer>{title}</LeftContainer>
          <CenterContainer>
            {hospitalName && (
              <>
                {' '}
                <HospitalIcon />
                {hospitalName}
              </>
            )}
          </CenterContainer>
          <RightContainer>
            <ProfileNameContainer>
              {profileName && profileName}
            </ProfileNameContainer>
            <CyIconDropdownButton
              iconElement={
                profileImage ? (
                  <IconImage src={profileImage} alt='profilePic' />
                ) : (
                  <Avatar />
                )
              }
              items={accountItems}
            />
          </RightContainer>
        </HeaderContainer>
      </AntdHeader>
    </>
  )
}

export default Header
